import type { AalExportPayload, AalView } from "../aalV2";
import { useAalExport } from "../aalV2";

export type DownloadAALSportsBetsPayload = AalExportPayload & {
  action_type?: string;
  bet_type?: string;
  bet_settlement?: string;
  bet_money_type?: string;
  agent_id?: string;
  agent_role_id?: string;
  target_user_id?: string;
  username?: string;
};

export const useDownloadAALSportsBetsTable = (view: AalView) =>
  useAalExport("sports-bets", view);
